"use strict";

var _defineProperty = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var SalesDashboardRowsDataDTO_1 = require("../model/SalesDashboardRowsDataDTO");

var NewSalesDashboardReportRowConverter_1 = require("./NewSalesDashboardReportRowConverter");

var SalesDashboardRowsDataDTOConverter_1 = require("./SalesDashboardRowsDataDTOConverter");

var SalesDashboardRowsDataDTOConverterImpl =
/*#__PURE__*/
function (_SalesDashboardRowsDa) {
  _inherits(SalesDashboardRowsDataDTOConverterImpl, _SalesDashboardRowsDa);

  function SalesDashboardRowsDataDTOConverterImpl(newSalesDashboardReportRowConverter) {
    var _this;

    _classCallCheck(this, SalesDashboardRowsDataDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SalesDashboardRowsDataDTOConverterImpl).call(this));
    _this.newSalesDashboardReportRowConverter = newSalesDashboardReportRowConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SalesDashboardRowsDataDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new SalesDashboardRowsDataDTO_1.SalesDashboardRowsDataDTO(conversions.asObject(source, 'rows', function (o) {
        return Object.keys(o).reduce(function (acc, cur) {
          return Object.assign(acc, _defineProperty({}, cur, _this2.newSalesDashboardReportRowConverter.toObject(source.rows[cur], conversions)));
        }, {});
      }), source.totalRowCount, source.expandedGroups ? conversions.asObjectSet(source, 'expandedGroups', function (d) {
        return d;
      }) : undefined);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        totalRowCount: source.totalRowCount,
        rows: Object.keys(source.rows).reduce(function (acc, cur) {
          return Object.assign(acc, _defineProperty({}, cur, _this3.newSalesDashboardReportRowConverter.toDocument(source.rows[cur], conversions)));
        }, {}),
        expandedGroups: source.expandedGroups ? conversions.asObjectArray(source, 'expandedGroups', function (c) {
          return c;
        }) : undefined
      });
      return result;
    }
  }]);

  return SalesDashboardRowsDataDTOConverterImpl;
}(SalesDashboardRowsDataDTOConverter_1.SalesDashboardRowsDataDTOConverter);

SalesDashboardRowsDataDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [NewSalesDashboardReportRowConverter_1.NewSalesDashboardReportRowConverter])], SalesDashboardRowsDataDTOConverterImpl);
exports.SalesDashboardRowsDataDTOConverterImpl = SalesDashboardRowsDataDTOConverterImpl;